"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapBridgeDevicesAndThings = void 0;
const mapBridgeDevicesAndThings = (bridges, things) => {
    const indexBridges = [];
    for (const bridge of bridges) {
        const realBridge = bridge;
        const thing = things.find((t) => t.deviceId === realBridge.id);
        if (typeof thing !== "undefined") {
            indexBridges.push(Object.assign(Object.assign({}, realBridge), { thingType: thing.type, sn: thing.model.serialNumber, primary_mesh_id: realBridge.mesh.addressId, primary_device_id: realBridge.id }));
        }
    }
    return indexBridges;
};
exports.mapBridgeDevicesAndThings = mapBridgeDevicesAndThings;
//# sourceMappingURL=Bridges.js.map